import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  hostListingConfigurationBegin,
  hostListingConfigurationSuccess,
  hostListingConfigurationErr,
  hostListingConfigurationUpdateBegin,
  hostListingConfigurationUpdateSuccess,
  hostListingConfigurationUpdateErr,
} = actions;

const fetchHostListingConfigurationAPI = `/admin/get-user-configurations/`;
const addEditHostListingConfigurationAPI = `/admin/add-edit-user-configuration`;


/**
 * Fetch host listing configuration
 * Mode determines behavior:
 * - '1' → DB only
 * - '2' → DB + static
 */
const getHostListingConfiguration = (hostSlug, mode = 1) => {
  return async (dispatch) => {
    dispatch(hostListingConfigurationBegin());

    try {
      const url = fetchHostListingConfigurationAPI + hostSlug + '?mode='+ mode
      const response = await DataService.get(url);

      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(hostListingConfigurationErr(response?.data?.message));
      } else {
        dispatch(hostListingConfigurationSuccess(response?.data));
      }

      return response?.data;
    } catch (err) {
      dispatch(hostListingConfigurationErr(err));
      return { status: HttpStatus.HTTP_INTERNAL_SERVER_ERROR, message: err };
    }
  };
};



const addEditHostListingConfiguration = (payload) => async (dispatch) => {
  dispatch(hostListingConfigurationUpdateBegin());
  try {
    const response = await DataService.post(addEditHostListingConfigurationAPI, payload)
    const { data } = response;

    if (data?.status !== HttpStatus.HTTP_OK) {
      dispatch(hostListingConfigurationUpdateErr(data?.message));
    } else {
      dispatch(hostListingConfigurationUpdateSuccess(data));
    }

    return data;
  } catch (err) {
    dispatch(hostListingConfigurationUpdateErr(err));
    return { status: HttpStatus.HTTP_INTERNAL_SERVER_ERROR, message: err };
  }
};

export { getHostListingConfiguration, addEditHostListingConfiguration };